import {useCallback} from 'react';
import {devConsoleError} from '../util';

function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
}

const HUBSPOT_POLL_INTERVAL = 1000; // milliseconds
const HUBSPOT_POLL_TIMEOUT = 30000; // milliseconds

export function useHubSpot() {
    const getHubSpot = useCallback(() => {
        if (!window.HubSpotConversations) {
            devConsoleError('HubSpotConversations is not available on the window object');
        }

        return window.HubSpotConversations;
    }, []);

    const waitForHubSpotToInit = useCallback(async () => {
        for (let i = 0; i < Math.ceil(HUBSPOT_POLL_TIMEOUT / HUBSPOT_POLL_INTERVAL); i++) {
            if (window.HubSpotConversations) {
                return;
            }

            // eslint-disable-next-line no-await-in-loop
            await sleep(HUBSPOT_POLL_INTERVAL);
        }

        // eslint-disable-next-line no-magic-numbers
        devConsoleError(`HubSpotConversations did not load within ${HUBSPOT_POLL_TIMEOUT / 1000} seconds!`);
    }, []);

    const load = useCallback(() => {
        getHubSpot()?.widget?.load();
    }, []);

    const open = useCallback(() => {
        // Even though load and setUserEmail have most likely been called already in the HubSpotLoader, the open call
        // is throwing a warning that the widget isn't loaded. If load has already been called, then this load should
        // be a no-op and not affect anything...
        load();
        getHubSpot()?.widget?.open();
    }, []);

    const clear = useCallback(() => {
        getHubSpot()?.clear({resetWidget: true});
    }, []);

    const setUserEmail = useCallback((email, token) => {
        window.hsConversationsSettings = {
            identificationEmail: email,
            identificationToken: token,
        };
    }, []);

    return {
        clear,
        load,
        open,
        setUserEmail,
        waitForHubSpotToInit,
    };
}
